<template>
  <v-card flat tile>
    <v-container>
      <h4 class="text-center mb-4 mt-2 grey--text text--darken-3">Reset Password</h4>
      <v-form ref="forgot-form" lazy-validation onsubmit="return false;">
        <v-row justify="center">
          <v-col cols="10" md="10" class="py-0">
            <v-text-field
              v-model="email"
              outlined
              label="Email"
              v-on:keyup.enter="submitEmail"
              :rules="[rules.email]"
              clearable
              :validate-on-blur="true"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="10" class="py-0 text-center" v-if="info">
            <v-alert type="success">{{info}}</v-alert>
          </v-col>
          <v-col cols="12" md="10" class="py-0 text-center" v-if="error">
            <v-alert type="error">{{error}}</v-alert>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-card-actions class="grey lighten-3">
      <v-btn icon to="/">
        <v-icon>fa-home</v-icon>
      </v-btn>
      <v-spacer></v-spacer>

      <v-btn class="primary" v-if="!submitted" @click="submitEmail" :loading="loading">Submit</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "",
  data: () => ({
    loading: false,
    submitted: false,
    error: "",
    info: "",
    email: "",
  }),
  methods: {
    async submitEmail() {
      if (!this.$refs["forgot-form"].validate()) {
        return;
      }
      this.loading = true;
      this.error = "";
      this.info = "";
      try {
        await this.$api.post("/forgot-password", { email: this.email });
        this.info = "Please check your email for a link to reset your password";
        this.submitted = true;
      } catch (ex) {
        this.error = ex.error;
      }
      this.loading = false;
    },
  },
  computed: {
    rules() {
      return {
        ...this.$helpers.rules,
      };
    },
    bgStyle() {
      return `background-image:url("${this.$store.state.app.background}")`;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
